export enum Permission {
  AuditLogs = 'audit_logs.view',
}
